import { useQuery } from '@tanstack/react-query'
import { getDocumentHistory } from '@wove/api'

export const useDocumentHistory = (shipmentId: string, documentId: string) => {
  return useQuery({
    queryKey: ['documentHistory', shipmentId, documentId],
    queryFn: () => getDocumentHistory(shipmentId, documentId).then(result => result.data),
  })
}
